module.exports = __webpack_public_path__ + "media/images/pic/hero/stats-wave-8f36c110b297c989e7f65308efa40ca3.webp";